// gql/queries/useGetEventPerformance.js
import { useQuery } from '@apollo/react-hooks';
import { gql } from 'graphql-tag';

export const GET_EVENT_PERFORMANCE = gql`
  query GetEventPerformanceTable($input: GetEventPerformanceInput!) {
    getEventPerformance(input: $input) {
      event_id
      event_name
      date
      app_sales
      pos_sales
      app_profit
      pos_profit
      total_profit
    }
  }
`;

export function useGetEventPerformance(account_id, year) {
  const { data, loading, error } = useQuery(GET_EVENT_PERFORMANCE, {
    variables: { input: { account_id, year } },
    fetchPolicy: 'no-cache',
    skip: !account_id || !year,
  });

  return { data, loading, error };
}
